import * as yup from "yup";
import { containsObsceneWords } from "@/utils/contentValidationUtils";

export const RegistrationTeamSchema = yup
  .object({
    name: yup
      .string()
      .required("Nome obrigatório")
      .test("no-obscene-content", "O nome contém conteúdo inapropriado", (value) => {
        if (!value) return true; // Skip validation if empty (required will catch this)
        return containsObsceneWords(value).isValid;
      }),
    teamTag: yup
      .string()
      .required("Tag obrigatória")
      .test("no-obscene-content", "A tag contém a palavra inapropriada", (value) => {
        if (!value) return true; // Skip validation if empty (required will catch this)
        const result = containsObsceneWords(value);
        if (!result.isValid) {
          return new yup.ValidationError(`A tag contém a palavra inapropriada "${result.foundWord}"`, value, "teamTag");
        }
        return true;
      }),
    game_id: yup.string().required("jogo obrigatório"),
    description: yup
      .string()
      .required("Descrição obrigatória")
      .test("no-obscene-content", "A descrição contém conteúdo inapropriado", (value) => {
        if (!value) return true; // Skip validation if empty (required will catch this)
        return containsObsceneWords(value).isValid;
      }),
  })
  .required();

export const UpdateTeamSchema = yup
  .object({
    id: yup.string().required(),
    name: yup
      .string()
      .required("Nome obrigatório")
      .test("no-obscene-content", "O nome contém conteúdo inapropriado", (value) => {
        if (!value) return true; // Skip validation if empty (required will catch this)
        return containsObsceneWords(value).isValid;
      }),
    teamTag: yup
      .string()
      .required("Tag obrigatória")
      .test("no-obscene-content", "A tag contém a palavra inapropriada", (value) => {
        if (!value) return true; // Skip validation if empty (required will catch this)
        const result = containsObsceneWords(value);
        if (!result.isValid) {
          return new yup.ValidationError(`A tag contém a palavra inapropriada "${result.foundWord}"`, value, "teamTag");
        }
        return true;
      }),
    description: yup
      .string()
      .required("Descrição obrigatória")
      .test("no-obscene-content", "A descrição contém conteúdo inapropriado", (value) => {
        if (!value) return true; // Skip validation if empty (required will catch this)
        return containsObsceneWords(value).isValid;
      }),
  })
  .required();

export const CreateJobVacancySchema = yup
  .object({
    team_id: yup.string(), // Optional as it's handled by the hook
    title: yup
      .string()
      .required("Título da vaga é obrigatório")
      .min(3, "Título deve ter pelo menos 3 caracteres")
      .test("no-obscene-content", "O título contém a palavra inapropriada", (value) => {
        if (!value) return true; // Skip validation if empty (required will catch this)
        const result = containsObsceneWords(value);
        if (!result.isValid) {
          return new yup.ValidationError(`O título contém a palavra inapropriada "${result.foundWord}"`, value, "title");
        }
        return true;
      }),
    position: yup.string().required("Posição é obrigatória"),
    number_of_vacancies: yup
      .number()
      .required("Número de vagas é obrigatório")
      .min(1, "Deve haver pelo menos 1 vaga"),
    min_ranking: yup
      .number()
      .min(0, "Ranking mínimo deve ser maior ou igual a 0"),
    description: yup
      .string()
      .min(10, "Descrição deve ter pelo menos 10 caracteres")
      .test("no-obscene-content", "A descrição contém a palavra inapropriada", (value) => {
        if (!value) return true; // Skip validation if empty (required will catch this)
        const result = containsObsceneWords(value);
        if (!result.isValid) {
          return new yup.ValidationError(`A descrição contém a palavra inapropriada "${result.foundWord}"`, value, "description");
        }
        return true;
      }),
    is_active: yup.boolean(),
  })
  .required();

// Define form schema with Yup
export const teamSettingsSchema = yup
  .object({
    // Team fields
    name: yup
      .string()
      .required("Nome da equipe é obrigatório")
      .min(3, "Nome deve ter pelo menos 3 caracteres")
      .test("no-obscene-content", "O nome contém conteúdo inapropriado", (value) => {
        if (!value) return true; // Skip validation if empty (required will catch this)
        return containsObsceneWords(value).isValid;
      }),
    team_tag: yup
      .string()
      .required("Tag da equipe é obrigatória")
      .max(5, "Tag deve ter no máximo 5 caracteres")
      .test("no-obscene-content", "A tag contém a palavra inapropriada", (value) => {
        if (!value) return true; // Skip validation if empty (required will catch this)
        const result = containsObsceneWords(value);
        if (!result.isValid) {
          return new yup.ValidationError(`A tag contém a palavra inapropriada "${result.foundWord}"`, value, "team_tag");
        }
        return true;
      }),
    description: yup
      .string()
      .required("Descrição é obrigatória")
      .min(10, "Descrição deve ter pelo menos 10 caracteres")
      .test("no-obscene-content", "A descrição contém conteúdo inapropriado", (value) => {
        if (!value) return true; // Skip validation if empty (required will catch this)
        return containsObsceneWords(value).isValid;
      }),
    show_team_members: yup.boolean(),
    is_recruiting: yup.boolean(),

    // Configuration fields
    primary_color: yup
      .string()
      .matches(
        /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/,
        "Cor primária deve ser um código hexadecimal válido"
      ),
    secondary_color: yup
      .string()
      .matches(
        /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/,
        "Cor secundária deve ser um código hexadecimal válido"
      ),
    notifications_enabled: yup.boolean(),
  })
  .required();
